import Pill from '@components/shared/PillWithDropdown/Pill';
import React from 'react';

interface QuickFilterProps {
	label: string;
	onClick: () => void;
}

export const QuickFilter = ({ label, onClick }: QuickFilterProps) => {
	return <Pill label={label} onClick={onClick} selected={false} />;
};
